export const EXECUTIVE_SCORE_CONFIG = {
  hq_performance: {
    label: "HQ Performance",
    scoreRange: "0-100",
    weights: {
      achievement: 0.4,
      growth: 0.25,
      coverage: 0.2,
      compliance: 0.15,
    },
    thresholds: {
      critical: { max: 64 },
      warning: { min: 65, max: 79 },
      healthy: { min: 80 },
    },
    missingData: "Missing metric values are excluded and remaining weights are rebalanced.",
  },
  brand_performance: {
    label: "Brand Performance",
    scoreRange: "0-100",
    weights: {
      achievement: 0.45,
      growth: 0.25,
      contribution: 0.15,
      stockistAvailability: 0.15,
    },
    thresholds: {
      critical: { max: 64 },
      warning: { min: 65, max: 79 },
      healthy: { min: 80 },
    },
    missingData: "Missing metric values are excluded and remaining weights are rebalanced.",
  },
  stockist_performance: {
    label: "Stockist Performance",
    scoreRange: "0-100",
    weights: {
      momGrowth: 0.35,
      currentSales: 0.25,
      consistency: 0.2,
      contribution: 0.2,
    },
    thresholds: {
      critical: { max: 59 },
      warning: { min: 60, max: 79 },
      healthy: { min: 80 },
    },
    missingData: "New stockists are scored without prior-month growth until comparison sales are available.",
  },
  sales_performance: {
    label: "Sales Performance",
    scoreRange: "0-100",
    weights: {
      achievement: 0.45,
      salesGap: 0.2,
      growth: 0.25,
      rank: 0.1,
    },
    thresholds: {
      critical: { max: 64 },
      warning: { min: 65, max: 79 },
      healthy: { min: 80 },
    },
    missingData: "Rows with missing comparison sales show actual values and suppress misleading percentages.",
  },
  coverage: {
    label: "Coverage",
    scoreRange: "0-100",
    weights: {
      currentCoverage: 0.35,
      coverageLag1: 0.2,
      coverageLag2: 0.15,
      coverageLag3: 0.1,
      coverageTrend: 0.2,
    },
    thresholds: {
      critical: { max: 69 },
      warning: { min: 70, max: 84 },
      healthy: { min: 85 },
    },
    missingData: "Lag metrics are calculated only within the same TM, HQ, division, and month sequence.",
  },
  compliance: {
    label: "Compliance",
    scoreRange: "0-100",
    weights: {
      currentCompliance: 0.35,
      complianceLag1: 0.2,
      complianceLag2: 0.15,
      complianceLag3: 0.1,
      complianceTrend: 0.2,
    },
    thresholds: {
      critical: { max: 69 },
      warning: { min: 70, max: 84 },
      healthy: { min: 85 },
    },
    missingData: "Lag metrics are calculated only within the same TM, HQ, division, and month sequence.",
  },
  doctor_coverage: {
    label: "Doctor Coverage",
    scoreRange: "0-100",
    weights: {
      listedDoctorCoverage: 0.4,
      callFrequency: 0.25,
      missedDoctors: 0.2,
      trend: 0.15,
    },
    thresholds: {
      critical: { max: 69 },
      warning: { min: 70, max: 84 },
      healthy: { min: 85 },
    },
    missingData: "Doctor-level gaps are flagged with counts even when call-frequency percentages are unavailable.",
  },
  tm_performance: {
    label: "Employee or TM Performance",
    scoreRange: "0-100",
    weights: {
      achievement: 0.3,
      coverage: 0.25,
      compliance: 0.25,
      growth: 0.2,
    },
    thresholds: {
      critical: { max: 64 },
      warning: { min: 65, max: 79 },
      healthy: { min: 80 },
    },
    missingData: "Missing sales or activity values are shown as unavailable and excluded from the score.",
  },
  risk_criticality: {
    label: "Risk or Criticality Score",
    scoreRange: "0-100",
    weights: {
      negativeGrowth: 0.3,
      achievementGap: 0.25,
      coverageGap: 0.2,
      complianceGap: 0.15,
      businessImpact: 0.1,
    },
    thresholds: {
      critical: { min: 75 },
      warning: { min: 50, max: 74 },
      healthy: { max: 49 },
    },
    missingData: "Rows with incomplete risk inputs remain visible and are flagged as limited evidence.",
  },
};

export const CORRELATION_STRENGTH_BANDS = [
  { min: 0.7, max: 1, label: "Strong positive relationship" },
  { min: 0.4, max: 0.69, label: "Moderate positive relationship" },
  { min: 0.2, max: 0.39, label: "Weak positive relationship" },
  { min: -0.19, max: 0.19, label: "Very weak or no linear relationship" },
  { min: -0.39, max: -0.2, label: "Weak negative relationship" },
  { min: -0.69, max: -0.4, label: "Moderate negative relationship" },
  { min: -1, max: -0.7, label: "Strong negative relationship" },
];

export const EXECUTIVE_ANALYTICS_GRAIN = [
  "Territory Manager",
  "HQ",
  "Division",
  "Year-Month",
];

export default EXECUTIVE_SCORE_CONFIG;
